import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import {
  googleAnalyticsSrc,
  googleTagManagerScript,
} from 'Utils/thirdParty/marketingToolScripts';
import ProjectConfig from 'ProjectConfig';
import PropTypes from 'prop-types';

const runWhenIdle = (callback, timeout = 4000) => {
  if (typeof window === 'undefined') return;
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, { timeout });
  } else {
    setTimeout(callback, 1);
  }
};

const MarketingTools = ({ deferred = false }) => {

  const gtmCode  = ProjectConfig.GTM_CODE;

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const insertNoscript = () => {
      if (document.getElementById('gtm-noscript')) return;
      const noscript = document.createElement('noscript');
      noscript.id = 'gtm-noscript';
      noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id='${gtmCode}'"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.insertBefore(noscript, document.body.firstChild);
    };

    const insertDeferredScripts = () => {
      if (!document.getElementById('ga-script')) {
        const gaScript = document.createElement('script');
        gaScript.id = 'ga-script';
        gaScript.async = true;
        gaScript.src = googleAnalyticsSrc;
        document.head.appendChild(gaScript);
      }

      if (!document.getElementById('gtm-inline-script')) {
        const gtmScript = document.createElement('script');
        gtmScript.id = 'gtm-inline-script';
        gtmScript.text = googleTagManagerScript;
        document.head.appendChild(gtmScript);
      }
    };

    if (!deferred) {
      insertNoscript();
      return;
    }

    const start = () => {
      runWhenIdle(() => {
        insertDeferredScripts();
        insertNoscript();
      }, 6000);
    };

    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start, { once: true });
    }
  }, [deferred, gtmCode]);


  const renderGA
    = <Helmet>
      <script async src={ googleAnalyticsSrc }/>
      { /* <script>{ googleAnalyticsScript }</script> */ }
    </Helmet>;


  const renderGTM
    = <Helmet>
      <script>{ googleTagManagerScript }</script>
    </Helmet>;

  return (
    <>
      { !deferred && renderGA }
      { !deferred && renderGTM }
    </>
  );

};

MarketingTools.propTypes = {
  deferred: PropTypes.bool,
};

export default MarketingTools;
